import React, { useState, useEffect } from "react";
import {
  Space,
  Row,
  Col,
  Switch,
  Form,
  Drawer,
  Button,
  message,
  Skeleton,
  Divider,
} from "antd";
import ContractTemplateEditor from "@general/contractTemplateEditor";
import WorkSpaceInputs from "../inputs/workSpace";
import { gql, useMutation, useLazyQuery } from "@apollo/client";
import DeleteCoreProduct from "@general/deleteCoreProduct";
import moment from "moment-jalaali";

const UPDATEWORKSPACE = gql`
  mutation updateWorkSpace(
    $updateWorkSpaceInput: UpdateWorkSpaceInput!
    $id: ID!
  ) {
    updateWorkSpace(updateWorkSpaceInput: $updateWorkSpaceInput, id: $id)
  }
`;

const GETPRODUCT = gql`
  query ($id: ID!) {
    getProduct(id: $id) {
      createdAt
      updatedAt
      contract
      name
      description
    }
      getProductContractVariable{
        name
        title
      }
  }
`;

function WorkSpaceDetails({ id, onDataUpdate }) {
  const [form] = Form.useForm();
  const [error, setError] = useState(null);
  const [editable, setEditable] = useState(false);
  const [workSpaceContractDrawer, setWorkSpaceDrawer] = useState(false);
  const [workSpaceContract, setWorkSpaceContract] = useState("<html></html>");
  const [initialData, setInitialData] = useState({});
  const [productContractVars, setProductContractVars] = useState(null);
  const [runUpdateWorkSpace, updateWorkSpace] = useMutation(UPDATEWORKSPACE, {
    onCompleted() {
      message.success("خدمت بروزرسانی شد.");
      onDataUpdate();
    },
    onError(err) {
      console.log("خطا: " + err.message);
      message.error("مشکلی پیش آمده! خدمت بروزرسانی نشد.");
    },
  });

  const doUpdateData = (updateWorkSpaceInput) => {
    runUpdateWorkSpace({
      variables: {
        id,
        updateWorkSpaceInput: {
          ...updateWorkSpaceInput,
          contract: workSpaceContract,
        },
      },
    });
  };
  const [getServiceData, serviceData] = useLazyQuery(GETPRODUCT, {
    fetchPolicy: "no-cache",
    onCompleted({ getProduct, getProductContractVariable }) {
      setProductContractVars(getProductContractVariable);
      const { createdAt, updatedAt, name, contract, description } = getProduct;
      const serviceData = {
        name,
        contract,
        description,
      };
      form.setFieldsValue(serviceData);
      setWorkSpaceContract(contract);
      setInitialData({
        createdAt: createdAt && moment(createdAt).format("jYYYY/jMM/jDD"),
        updatedAt: updatedAt && moment(updatedAt).format("jYYYY/jMM/jDD"),
        contract,
      });
    },
  });
  useEffect(() => {
    if (id) {
      getServiceData({
        variables: {
          id,
        },
      });
    }
    setEditable(false);
  }, [id]);
  const { createdAt, updatedAt } = initialData;
  if (serviceData.loading)
    return (
      <>
        <Skeleton active round />
        <br />
        <Skeleton active round />
      </>
    );
  return (
    <div>
      <Drawer
        title={"تعهدنامه استفاده از فضای کار"}
        placement="top"
        open={workSpaceContractDrawer}
        onClose={() => setWorkSpaceDrawer(false)}
        height={550}
      >
        <ContractTemplateEditor
          contract={workSpaceContract}
          onCloseDrawer={() => setWorkSpaceDrawer(false)}
          onEditContract={(newContract) => setWorkSpaceContract(newContract)}
          helpVars={productContractVars}
        />
      </Drawer>
      <Row>
        <Col sm={12} xs={24}>
          <Space align="">
            <p>تاریخ ثبت: </p>
            {createdAt}
          </Space>
        </Col>
        <Col sm={12} xs={24}>
          <Space align="">
            <p>آخرین بروزرسانی: </p>
            {updatedAt}
          </Space>
        </Col>
      </Row>
      <Divider />
      <Row>
        <Space align>
          <p>ویرایش: </p>
          <Switch onChange={() => setEditable(!editable)} />
        </Space>
      </Row>
      <Form
        layout="vertical"
        onFinish={doUpdateData}
        form={form}
        disabled={!editable}
      >
        <Row gutter={15}>
          <Col xs={24} lg={24}>
            <WorkSpaceInputs
              error={error}
              onSetWorkSpaceDrawer={setWorkSpaceDrawer}
            />
          </Col>
        </Row>
        <Space>
          <Button
            type="primary"
            htmlType="submit"
            loading={updateWorkSpace.loading && true}
          >
            بروزرسانی
          </Button>
          <DeleteCoreProduct
            id={id}
            onDeleteCoreProduct={onDataUpdate}
            error={error}
            onSetWorkSpaceDrawer={setWorkSpaceDrawer}
          >
            <Button danger>حذف</Button>
          </DeleteCoreProduct>
        </Space>
      </Form>
    </div>
  );
}

export default WorkSpaceDetails;
